(() => {
if (customElements.get('wildgainz-mobile-nav')) return;
/* Wild Gainz mobile menu accordion.
   Progressive enhancement: without this script every group renders open
   (the stylesheet only hides panels under .wg-js). Groups are buttons, not
   details/summary, so Dawn's header-drawer script (which binds every
   summary in the drawer to its sliding submenus) leaves them alone.

   Dawn's MenuDrawer binds a submenu-close handler to every button inside
   <header-drawer> (global.js bindEvents), which would close the whole
   drawer on a toggle tap. The click listener below is registered in the
   capture phase on this element, an ancestor of the buttons, and stops
   propagation before the event reaches Dawn's listener on the button.

   Markup contract (snippets/wildgainz-header-drawer.liquid):
     <wildgainz-mobile-nav data-exclusive="true|false">
       <li data-mnav-group [data-mnav-open]>
         <button data-mnav-toggle aria-expanded aria-controls>...</button>
         <div data-mnav-panel id>...</div>
       </li>
     </wildgainz-mobile-nav>
*/
class WildgainzMobileNav extends HTMLElement {
  connectedCallback() {
    this.classList.add('wg-js');
    if (this.__wgBound) return;
    this.__wgBound = true;

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-mnav-toggle]');
      if (!button || !this.contains(button)) return;
      const group = button.closest('[data-mnav-group]');
      if (!group) return;
      // Capture phase: stop here so Dawn's close handler on the button,
      // which would shut the whole drawer, never runs.
      event.stopPropagation();
      const open = group.hasAttribute('data-mnav-open');
      if (!open && this.dataset.exclusive === 'true') {
        this.querySelectorAll('[data-mnav-group][data-mnav-open]').forEach((other) => {
          if (other !== group) this.setOpen(other, false);
        });
      }
      this.setOpen(group, !open);
    }, { capture: true });

    // The theme editor can strip classes when it morphs the header in
    // place; keep the enhancement marker so panels do not all fall open.
    this.__wgObserver = new MutationObserver(() => {
      if (!this.classList.contains('wg-js')) this.classList.add('wg-js');
    });
    this.__wgObserver.observe(this, { attributes: true, attributeFilter: ['class'] });
  }

  setOpen(group, open) {
    group.toggleAttribute('data-mnav-open', open);
    const button = group.querySelector('[data-mnav-toggle]');
    if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
}

customElements.define('wildgainz-mobile-nav', WildgainzMobileNav);
})();
